import React from "react";
import { PeekListItem, PeekListItemButton, PeekListItemText, PeekStack, useTheme, } from "@piiqtechnologies/ui-components";
import { useOptionalPlansBillingContext } from "@stores/PlansBillingContext";
export const NavigationListItem = ({ label, icon, isActive, forceActive, className, disabled, onClick, }) => {
    var _a;
    const theme = useTheme();
    const isPlansBillingOpen = Boolean((_a = useOptionalPlansBillingContext()) === null || _a === void 0 ? void 0 : _a.isPlansBillingOpen);
    const effectiveActive = forceActive ? isActive : !isPlansBillingOpen && isActive;
    return (React.createElement(PeekListItem, { key: label, disablePadding: true, className: className },
        React.createElement(PeekListItemButton, { onClick: onClick, disabled: disabled, sx: {
                backgroundColor: effectiveActive ? theme.palette.teal[100] : "initial",
                borderRadius: 1,
                height: theme.spacing(3.6),
                pl: 1,
                ml: -1,
            } },
            React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.5 },
                icon,
                React.createElement(PeekListItemText, { primary: label, primaryTypographyProps: {
                        variant: "body1",
                        fontWeight: effectiveActive ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
                    } })))));
};
export default NavigationListItem;
